module.exports = __webpack_public_path__ + "static/media/cityscape.bd615cb0.svg";